export default __webpack_public_path__ + "static/mid-ground-01-d55d52abd8e903f36c0e11d6570b3409.png";